// import React from "react"
// import {
//   UserIcon,
//   CheckBadgeIcon,
//   QrCodeIcon,
//   PrinterIcon,
//   DocumentTextIcon,
//   IdentificationIcon,
// } from "@heroicons/react/24/outline"

// const StatisticsCardsInstitution = ({ statistics, residents }) => {
//   const totalResidents = residents.length
//   const withDigitalId = residents.filter(
//     (r) => r.barangay_id_number && r.status === "active"
//   ).length
//   const qrGenerated = residents.filter((r) => r.barangay_id_number).length // All with ID numbers have QR codes
//   const idsPrinted = residents.filter(
//     (r) => r.digital_id_issued_at || r.status === "verified"
//   ).length
//   const registeredVoters = residents.filter(
//     (r) => r.voter_status === "registered"
//   ).length
//   const documentsIssued = residents.filter(
//     (r) =>
//       r.created_at &&
//       new Date(r.created_at).getMonth() === new Date().getMonth()
//   ).length

//   const stats = [
//     {
//       label: "Total Registered Institutions",
//       value: totalResidents,
//       icon: UserIcon,
//       bgColor: "bg-blue-100",
//       textColor: "text-blue-600",
//       description: "Overall count of institutions in the system",
//     },
//     {
//       label: "Active Institutions",
//       value: withDigitalId,
//       icon: IdentificationIcon,
//       bgColor: "bg-green-100",
//       textColor: "text-green-600",
//       description: "Currently operational and engaged institutions",
//     },

//     {
//       label: "Inactive Institutions",
//       value: idsPrinted,
//       icon: PrinterIcon,
//       bgColor: "bg-orange-100",
//       textColor: "text-orange-600",
//       description: "Institutions not active or on hold",
//     },
//   ]

//   return (
//     <div className='grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mb-8 animate-in slide-in-from-bottom duration-700 delay-200'>
//       {stats.map((stat, index) => (
//         <div
//           key={stat.label}
//           className='bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group'
//         >
//           <div className='flex items-center'>
//             <div className='flex-shrink-0'>
//               <div className='flex justify-between items-center gap-2'>
//                 <div
//                   className={`flex items-center justify-center w-12 h-12 ${stat.textColor} ${stat.bgColor} text-2xl font-bold rounded-lg group-hover:scale-110 transition-transform duration-200`}
//                 >
//                   {stat.value.toLocaleString()}
//                 </div>
//                 <div>
//                   <p className='text-sm font-medium text-gray-600'>
//                     {stat.label}
//                   </p>
//                   <p className='text-xs text-gray-500'>{stat.description}</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   )
// }

// export default StatisticsCardsInstitution

import React from "react"
import {
  UserIcon,
  IdentificationIcon,
  PrinterIcon,
} from "@heroicons/react/24/outline"

const StatisticsCardsInstitution = ({ statistics }) => {
  const stats = [
    {
      label: "Total Registered Institutions",
      value: statistics.total_institutions || 0,
      icon: UserIcon,
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
      description: "Overall count of institutions in the system",
    },
    {
      label: "Active Institutions",
      value: statistics.total_active_institutions || 0,
      icon: IdentificationIcon,
      bgColor: "bg-green-100",
      textColor: "text-green-600",
      description: "Currently operational and engaged institutions",
    },
    {
      label: "Inactive Institutions",
      value: statistics.total_inactive_institution || 0,
      icon: PrinterIcon,
      bgColor: "bg-orange-100",
      textColor: "text-orange-600",
      description: "Institutions not active or on hold",
    },
  ]

  return (
    <div className='grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mb-8 animate-in slide-in-from-bottom duration-700 delay-200'>
      {stats.map((stat) => (
        <div
          key={stat.label}
          className='bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group'
        >
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='flex justify-between items-center gap-2'>
                <div
                  className={`flex items-center justify-center w-12 h-12 ${stat.textColor} ${stat.bgColor} text-2xl font-bold rounded-lg group-hover:scale-110 transition-transform duration-200`}
                >
                  {stat.value.toLocaleString()}
                </div>
                <div>
                  <p className='text-sm font-medium text-gray-600'>
                    {stat.label}
                  </p>
                  <p className='text-xs text-gray-500'>{stat.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default StatisticsCardsInstitution
